<template>
  <el-dialog :model-value="show" :width="560" custom-class="tip-dialog" :before-close="closeDialog" append-to-body>
    <template #title>
      <div class="title">提示</div>
    </template>
    <div class="tip-content">
      <img src="@/assets/images//home//building.png" class="tip-image" alt="">
      <span class="tip-text">功能正在开发中，敬请期待。</span>
      </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" class="btn" @click="closeDialog">我知道了</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: Boolean,
  },
  emits: ["update:show"],
  methods: {
    closeDialog() {
      this.$emit("update:show", false);
    },
  },
};
</script>

<style lang="scss">
.tip-dialog {
  .el-dialog__header {
    padding: 16px 20px;
    border-bottom: solid 1px #DDDDDD;
  }
  .el-dialog__footer {
    padding: 0 20px 30px;
  }
}
</style>

<style lang="scss" scoped>
.title {
  color: #2A2A2A;
  font-size: 18px;
  position: relative;
  &::before {
    content: '';
    display: block;
    width: 6px;
    height: 28px;
    background: $--color-primary;
    position: absolute;
    left: -20px;
  }
}
.tip-content {
  display: flex;  
  flex-direction: column;
  align-items: center;
  .tip-image {
    width: 144px;
    margin-bottom: 16px;
  }
  .tip-text {
    color: #2A2A2A;
    font-size: 14px;
    font-family: PingFang SC-中黑体, PingFang SC;
  }
}

.dialog-footer {
  text-align: center;
  .btn {
    width: 132px;
    border-radius: 100px;
  }
}
</style>